// extracted by mini-css-extract-plugin
export default {"warning":"Delete_warning__LpSTv","label":"Delete_label__ZmRLR"};